import { ThemeProvider as NextThemesProvider } from "next-themes";
import type { ThemeProviderProps } from "next-themes";

/**
 * How the app's theme is resolved, in one place because it is one decision.
 *
 * Light or Dark, chosen per device; Light by default (BEN-141 theme option B: Anthony,
 * 2026-09-24, "Remove system from drop down and if the page is light then default to
 * light"; Paul picked B on 2026-10-08, report -95). This reverses #1188's
 * `enableSystem: true` / `defaultTheme: "system"`. Existing devices are migrated before
 * the first render by `lib/storedThemeMigration` (shared `resolveStoredTheme`): a stored
 * "system" becomes what the device showed at that moment, and nothing stored becomes light.
 * The dark palette in index.css is complete; ProfileMenu and LegalLayout read
 * `resolvedTheme`, which with System off is always the stored choice.
 */
export const APP_THEME_CONFIG = {
  attribute: "class",
  defaultTheme: "light",
  enableSystem: false,
  storageKey: "fomo-fi-theme",
} as const;

export function ThemeProvider({ children, ...props }: ThemeProviderProps) {
  return <NextThemesProvider {...props}>{children}</NextThemesProvider>;
}
